'use client'

import { parseAsString, useQueryStates } from 'nuqs'
import { URLSearchParamKeys } from "@/enum/URLSearchParamKeys.ts";
import { ModalTypes } from "@/enum/modalTypes.ts";

export function useModalQueryState(key: URLSearchParamKeys | ModalTypes) {
  const [modalState, setQueryStates] = useQueryStates(
    {
      [URLSearchParamKeys.MODAL]: parseAsString.withDefault(''),
      [key]: parseAsString.withDefault('')
    },
    {
      history: 'push',
      shallow: true,
      clearOnDefault: true,
    }
  );

  const setModalParam = (value: string | number | boolean | null) => {
    setModalParams({
      [key]: value + '',
    });
  };

  // Custom setter that ensures URLSearchParamKeys.MODAL is always present
  const setModalParams = (params: Partial<Record<string, string | number | null>>) => {
    setQueryStates({
      [URLSearchParamKeys.MODAL]: key,
      ...params,
    });
  };

  const unsetModalParam = () => {
    setQueryStates({
      [modalState.modal]: '',
      [URLSearchParamKeys.MODAL]: '',
    });
  };

  return {
    modalState,
    setModalParam,
    setModalParams,
    unsetModalParam,
  };
}
